const bannerElements = [
  {
    name: "title",
    type: "text",
    label: "Titre",
    col: 6,
  },
  {
    name: "subtitle",
    type: "text",
    label: "Sous-titre",
    col: 6,
  },
  {
    name: "image",
    type: "image",
    label: "Image",
    col: 12,
    resolution: "1920x1080",
  },
];

const informationElements = [
  // {
  //   name: "title",
  //   type: "text",
  //   label: "Titre",
  //   col: 6,
  // },
  // {
  //   name: "subtitle",
  //   type: "text",
  //   label: "Sous-titre",
  //   col: 6,
  // },
  {
    name: "name",
    type: "text",
    label: "Nom du produit",
    col: 6,
  },
  {
    name: "capacity",
    type: "text",
    label: "Nombre de place",
    col: 6,
  },
  {
    name: "price",
    type: "text",
    label: "Prix",
    col: 6,
  },
  {
    name: "promo",
    type: "boolean",
    label: "Promotion",
    col: 6,
  },
  {
    name: "promo_amount",
    type: "text",
    label: "Montant de la promotion",
    col: 6,
  },
  {
    name: "price_value",
    type: "text",
    label: "Prix promotionnel",
    col: 6,
  },
  {
    name: "dimensions",
    type: "text",
    label: "Dimensions",
    col: 6,
  },
  {
    name: "order",
    type: "text",
    label: "Ordre d'affichage",
    col: 6,
  },
  {
    name: "image",
    type: "image",
    label: "Image",
    col: 12,
    resolution: "600x600",
  },
];

const descriptionElements = [
  {
    name: "text",
    type: "textarea",
    col: 12,
  },
];

const characteristicsElements = [
  {
    label: "Éléments",
    name: "list",
    type: "array",
    elements: [
      {
        name: "label",
        type: "text",
        label: "Étiquette",
        col: 6,
      },
      {
        name: "value",
        type: "text",
        label: "Valeur",
        col: 6,
      },
    ],
  },
];

const introductionElements = [
  {
    name: "media",
    type: "media",
    label: "Video",
    col: 12,
    resolution: "1920x1080",
  },
  {
    name: "text",
    type: "text",
    textArea: true,
    label: "Description",
    col: 12,
  },
];

const processElements = [
  {
    label: "Liste",
    name: "items",
    type: "array",
    elements: [
      {
        name: "title",
        type: "text",
        label: "Titre",
        col: 6,
      },
      {
        name: "image",
        type: "image",
        label: "Image",
        isMultiple: true,
        col: 12,
        resolution: "600x500",
      },
      {
        name: "description",
        type: "text",
        textArea: true,
        label: "Description",
        col: 12,
      },
    ],
  },
];

const innovationElements = [
  {
    label: "Liste",
    name: "items",
    type: "array",
    elements: [
      {
        name: "title",
        type: "text",
        label: "Titre",
        col: 6,
      },
      {
        name: "subtitle",
        type: "text",
        label: "Sous-titre",
        col: 6,
      },
      {
        name: "description",
        type: "text",
        label: "Description",
        col: 6,
      },
      {
        name: "icon",
        type: "image",
        label: "Icone",
        col: 12,
        resolution: null,
      },
      {
        name: "image",
        type: "image",
        label: "Image",
        col: 12,
        resolution: "1920x1080",
      },
    ],
  },
];

const innovationTabsElements = [
  {
    label: "Liste",
    name: "items",
    type: "array",
    elements: [
      {
        name: "title",
        type: "text",
        label: "Titre",
        col: 6,
      },
      {
        name: "text",
        type: "text",
        textArea: true,
        label: "Description",
        col: 12,
      },
      {
        name: "image",
        type: "image",
        label: "Image ou video",
        col: 12,
        resolution: "1024×576",
      },
    ],
  },
];

const completeHydrotherapyElements = [
  {
    name: "image",
    type: "image",
    label: "Image",
    col: 12,
    resolution: "1000x1000",
  },
  {
    label: "Liste",
    name: "seat",
    type: "array",
    elements: [
      {
        label: "Éléments",
        name: "items",
        type: "array",
        elements: [
          {
            name: "description",
            type: "text",
            textArea: true,
            label: "Description",
            col: 12,
          },
          {
            name: "description2",
            type: "text",
            textArea: true,
            label: "Description (1)",
            col: 12,
          },
          {
            name: "images",
            type: "image",
            multiple: true,
            label: "Images",
            col: 12,
            resolution: "1500×1000",
          },
        ],
      },
    ],
  },
];

const jetsElements = [
  {
    label: "Liste",
    name: "items",
    type: "array",
    elements: [
      {
        name: "title",
        type: "text",
        label: "Titre",
        col: 12,
      },
      {
        name: "description",
        type: "text",
        textArea: true,
        label: "Description",
        col: 12,
      },
      {
        name: "icon",
        type: "image",
        label: "Icone",
        col: 12,
        resolution: "300x300",
      },
      {
        name: "image",
        type: "image",
        label: "Image",
        col: 12,
        resolution: "1500x1000",
      },
    ],
  },
];

const ergonomicDesignElements = [
  {
    label: "Liste",
    name: "items",
    type: "array",
    elements: [
      {
        name: "title",
        type: "text",
        label: "Titre",
        col: 6,
      },
      {
        name: "description",
        type: "text",
        textArea: true,
        label: "Description",
        col: 12,
      },
      {
        name: "image",
        type: "image",
        label: "Image",
        col: 12,
        resolution: "1900x600",
      },
    ],
  },
];

const minimalConsumptionElements = [
  {
    label: "Liste",
    name: "items",
    type: "array",
    elements: [
      {
        name: "title",
        type: "text",
        label: "Titre",
        col: 6,
      },
      {
        name: "description",
        type: "text",
        textArea: true,
        label: "Description",
        col: 12,
      },
      {
        name: "image",
        type: "image",
        label: "Image",
        col: 12,
        resolution: "600x500",
      },
    ],
  },
];

const structureElements = [
  {
    name: "title",
    type: "text",
    label: "Titre",
    col: 6,
  },
  {
    name: "description",
    type: "text",
    textArea: true,
    label: "Description",
    col: 12,
  },
  {
    name: "image",
    type: "image",
    label: "Image",
    col: 12,
    resolution: "1920x1080",
  },
];

const qualityElements = [
  {
    label: "Liste",
    name: "items",
    type: "array",
    elements: [
      {
        name: "title",
        type: "text",
        label: "Titre",
        col: 6,
      },
      {
        name: "description",
        type: "text",
        textArea: true,
        label: "Description",
        col: 12,
      },
      {
        name: "image",
        type: "image",
        label: "Image",
        col: 12,
        resolution: "1500x1000",
      },
    ],
  },
];

const warrantyElements = [
  {
    name: "title",
    type: "text",
    label: "Titre",
    col: 6,
  },
  {
    name: "image",
    type: "image",
    label: "Image",
    resolution: "1920x1080",
    col: 12,
  },
  {
    label: "Liste",
    name: "items",
    type: "array",
    elements: [
      {
        name: "title",
        type: "text",
        label: "Titre",
        col: 6,
      },
      {
        name: "subtitle",
        type: "text",
        label: "Sous-titre",
        col: 6,
      },
      {
        name: "icon",
        type: "image",
        label: "Icone",
        col: 12,
        resolution: "116×124",
      },
    ],
  },
];

const optimalErgonomicsElements = [
  {
    label: "Liste",
    name: "items",
    type: "array",

    elements: [
      {
        name: "title",
        type: "text",
        label: "Titre",
        col: 6,
      },
      {
        name: "description",
        type: "text",
        textArea: true,
        label: "Description",
        col: 12,
      },
      {
        name: "image",
        type: "image",
        label: "image",
        col: 12,
        resolution: "1920x1080",
      },
    ],
  },
];

const customizationElements = [
  {
    name: "title",
    type: "text",
    label: "Titre",
    col: 6,
  },
  {
    name: "description",
    type: "text",
    textArea: true,
    label: "Description",
    col: 12,
  },
  {
    label: "Liste des panneaux",
    name: "panels",
    type: "array",
    elements: [
      {
        name: "panelTitle",
        type: "text",
        label: "Titre",
        col: 12,
      },
      {
        name: "panelImage",
        type: "image",
        label: "Image",
        col: 6,
        resolution: "180×160",
      },
      {
        name: "image",
        type: "image",
        label: "Image",
        col: 6,
        resolution: "1900x600",
      },
    ],
  },
];

const otherPanelsElements = [
  {
    name: "postDescription",
    type: "text",
    textArea: true,
    label: "Description",
    col: 12,
  },
  {
    label: "Liste des autres panneaux",
    name: "otherPanels",
    type: "array",
    elements: [
      {
        name: "title",
        type: "text",
        label: "Titre",
        col: 12,
      },
      {
        name: "panelImage",
        type: "image",
        label: "image",
        col: 12,
        resolution: "200x200",
      },
    ],
  },
];

const factoryElements = [
  {
    label: "Liste",
    name: "items",
    type: "array",
    elements: [
      {
        name: "image",
        type: "image",
        label: "Image",
        col: 6,
        resolution: "1280x720",
      },
    ],
  },
];

const partnerElements = [
  {
    label: "Liste",
    name: "partnerTabs",
    type: "array",
    elements: [
      {
        name: "title",
        type: "text",
        label: "Titre",
        col: 12,
      },
      {
        label: "Éléments",
        name: "items",
        type: "array",
        elements: [
          {
            name: "title",
            type: "text",
            label: "Titre",
            col: 12,
          },
          {
            name: "text",
            type: "text",
            textArea: true,
            label: "Description",
            col: 12,
          },
          {
            name: "image",
            type: "image",
            label: "Image",
            col: 12,
            resolution: "1200×800",
          },
        ],
      },
    ],
  },
];

const forms = {
  files: {
    title: "Fiche technique",
    elements: [
      {
        name: "technicalFile",
        type: "image",
        resolution: null,
        label: "Fiche technique",
      },
    ],
  },
  banner: {
    title: "Bannière du produit",
    elements: bannerElements,
  },
  informations: {
    title: "Informations du produit",
    elements: informationElements,
  },
  description: {
    title: "Description du produit",
    elements: descriptionElements,
  },
  characteristics: {
    title: "Caractéristiques du produit",
    elements: characteristicsElements,
  },
  introduction: {
    title: "Fabrication Française",
    elements: introductionElements,
  },
  features: {
    title: "Processus de Fabrication",
    elements: processElements,
  },
  innovation: {
    title: "Innovations Incomparables",
    elements: innovationElements,
  },
  innovationTabs: {
    title: "Onglets Innovations",
    elements: innovationTabsElements,
  },
  hydrotherapySeats: {
    title: "Une hydrothérapie complète",
    elements: completeHydrotherapyElements,
  },
  jets: {
    title: "Jets",
    elements: jetsElements,
  },
  ergonomicDesign: {
    title: "Une ergonomie et un design unique et immersif",
    elements: ergonomicDesignElements,
  },
  minimalConsumption: {
    title: "Une consommation minimale",
    elements: minimalConsumptionElements,
  },
  structure: {
    title: "Structure de produit",
    elements: structureElements,
  },
  quality: {
    title: "Une qualité inegalable",
    elements: qualityElements,
  },
  warranty: {
    title: "Garanties",
    elements: warrantyElements,
  },
  partners: {
    title: "Des partenaires",
    elements: partnerElements,
  },
  optimalErgonomics: {
    title: "Une ergonomie optimale",
    elements: optimalErgonomicsElements,
  },
  customization: {
    title: "Personnalisation",
    elements: [...customizationElements, ...otherPanelsElements],
  },
  factory: {
    title: "Notre usine francaise dans le cantal",
    elements: factoryElements,
  },
};

export default forms;
